import angular from 'angular';
import RegisterEmailController from "./register-email.controller";
import RegisterDataController from "./register-data.controller";
import RegisterLoginController from "./register-login.controller";
import RegisterBirthdayController from "./register-birthday.controller";
import FetchForgottenPasswordFormService from "../password/fetch-forgotten-password-form.service";
import birthdayValidator from "./birthday-validator";

let register = angular
    .module('register', [])
    .controller('RegisterEmailController', RegisterEmailController)
    .controller('RegisterDataController', RegisterDataController)
    .controller('RegisterBirthdayController', RegisterBirthdayController)
    .controller('RegisterLoginController', RegisterLoginController)
    .controller('FetchForgottenPasswordFormService', FetchForgottenPasswordFormService)
    .directive('birthdayValidator', birthdayValidator);
export default register;
